import { Component } from '@angular/core';

@Component({
  selector: 'app-add-via-indent-button-2',
  templateUrl: './add-via-indent-button-2.component.html',
  styleUrls: ['./add-via-indent-button-2.component.css']
})
export class AddViaIndentButton2Component {

}
